<template>
<div class="table-responsive">    
<table class="table v-middle" style="max-height: 555px;
    overflow: hidden;
    display: block;">
    <thead>
        <tr class="">
            <th class="border-top-0">Тип</th>
            <th class="border-top-0">Статья</th>
            <th class="border-top-0">Дата</th>
        </tr>
    </thead>
    <tbody>
        <tr v-for="(item, i) in dataS" :key="i">
            <td>{{item.type}}</td>
            <td><a :href="item.URL" target="_blank">{{item.title}}</a><br/>{{item.text}}</td>
            <td>{{item.date}}</td>
        </tr>
    </tbody>
</table>
</div>
</template>
<script>
export default {
    name: "TopProducts",
    data() {
        return {
            colorx: '#f91f43',
            currentx: 0,
            dataS:[],
    dd:[
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/935091",
        "date": "2020-03-24, 11:27:43",
        "title": "Компания Facebook передала медикам 720 тысяч масок",
        "text": "Распространителей фейков о коронавирусе задержали в Кызылординской области Компания Facebook пожертвовала 720 тысяч медицинских масок работник...",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/935063",
        "date": "2020-03-24, 11:00:12",
        "title": "Елімізде коронавирус жұқтырғандар саны 62 адамға жетті",
        "text": "НҰР-СҰЛТАН. ҚазАқпарат - Елордада тағы 1 адамнан коронавирус шықты, деп хабарлайды ҚазАқпарат ҚР ДСМ Тауарлар мен көрсетілетін қызметтердің сапасы мен қауіпсіздігін бақылау комитетінің Телеграм каналына сілтеме жасап.",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/935058",
        "date": "2020-03-24, 10:53:19",
        "title": "Новый случай заражения коронавирусом выявили в Казахстане",
        "text": "Новый случай заражения коронавирусом выявили в Казахстане. На 13.50 часа 23 марта 2020 года в Казахстане зарегистрирован еще 1 случай заражения коронавирусной инфекцией в г. Нур-Султан, пишет NUR.KZ.",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/935025",
        "date": "2020-03-24, 10:22:45",
        "title": "Коронавирус: 2 ел Олимпиадаға қатыспайтындықтарын мәлімдеді",
        "text": "НҰР-СҰЛТАН. ҚазАқпарат \u2013 Коронавирус қатеріне байланысты әлемнің екі елі Токио Олимпиадасына бармайтындықтарын мәлімдеді, деп хабарлайды ҚазАқпарат тілшісі.",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/935022",
        "date": "2020-03-24, 10:21:52",
        "title": "Санитарные посты установлены при въезде в Талдыкорган",
        "text": "У водителей проверяют температуру, записывают данные. Такие пропускные пункты работают в Илийском, Талгарском и Карасайском районах. Именно в последнем районе был зарегистрирован мужчина с симптомами коронавируса и помещен в инфекционное отделение. Также на карантине находятся 10 человек, контактировавшие с больным, анализы на коронавирус показали отрицательный результат. В Талдыкоргане усилена работа по недопущению спекуляции средствами индивидуальной защиты и антисептиками. Ранее полицейские выявили целую партию незарегистрированных одноразовых масок.",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/935024",
        "date": "2020-03-24, 10:21:45",
        "title": "В Алматы оцепили подъезд еще одного жилого дома",
        "text": "Здание расположено в Алмалинском районе на пересечении улиц Богенбай Батыра и Ш. Айманова. Здесь предположительно проживает зараженный коронавирусом. Таким образом, так называемых «карантинных» домов в мегаполисе уже 10. Сотрудниками полиции сразу было выставлено заграждение и расставлены предупреждающие знаки. А работники эпидемиологической службы провели дезинфекцию подъезда и двора. Сейчас подъезд охраняют полицейские. Андрей Николаев, житель дома на карантине:- Каждый волонтер имеет свой бейдж. Жильцы создали много групп в социальной сети, в которые соответственно, отправляют имена волонтеров. Продукты и лекарства \u2013 мы оплачиваем. Надо понимать, что волонтеры не могут всё ради идеи. В конце \u2013 концов, нас много, а они одни.Андрей Николаев рассказал, что массовый осмотр медицинские работники провели в первый день, при этом просили придерживаться режима, и регулярно измерять температуру тела, в случае её повышения \u2013 немедленно звонить в скорую помощь и на горячую линию. С тех пор, медицинские работники так и не появлялись в самом доме, но врачи ежедневно обзванивают своих пациентов, которые находятся на учёте в поликлиниках. По обеспечению необходимыми дезинфицирующими средствами, предметами личной гигиены, и масками - жильцы «опасной» многоэтажки приобретают всё сами. С доставкой помогают волонтёры.",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/935038",
        "date": "2020-03-24, 10:21:29",
        "title": "В Кызылорде медицинские учреждения обеспечены средствами защиты",
        "text": "В Приаралье принимают усиленные меры для предотвращения распространения коронавирусной инфекции. Медицинские учреждения региона обеспечены достаточным запасом медикаментов. На приобретение защитных средств из республиканского и областного бюджетов выделено 26 миллионов тенге. Семинары, учебные тревоги и новый алгоритм действий. С появлением COVID-19 изменился регламент работы и у врачей скорой помощи. Акцентируют на повышенную температуру и признаки простуды, говорят врачи. Особенно, если пациент был за рубежом или контактировал с таковыми. Тогда на вызов бригада отправляется в специальном обмундировании. Алмат Курмангали, главный врач областной станции скорой медицинской помощи:- Были пациенты с подозрением на коронавирусную инфекцию, с повышенной температурой и другими симптомами, прибывшие в Кызылорду из-за рубежа и соседних регионов страны. Коронавируса у них не обнаружено. При транспортировке, изоляции, диагностике и лечении применён утверждённый алгоритм действий, который дал нам возможность приобрести необходимый опыт. В готовность приведены все медицинские учреждения региона. Они оснащены тепловизорами, приёмные отделения - дистанционными термометрами, для пациентов с симптомами коронавируса созданы зоны изоляции. Нурбол Махамбетияр, заместитель директора многопрофильной областной больницы:- Если пациент пришёл с повышенной температурой - ему выдают респираторную маску и помещают в изолятор. К такому больному допускается врач только в защитном костюме. Он собирает все анализы, регистрирует пациента и сообщает о ситуации главному врачу и эпидемиологу.На случай выявления инфицированных в Кызылорде открыт провизорный стационар на 100 человек. Ещё 400 койко-мест подготовлено для карантина. Рауан Мынбаев, пресс-секретарь акима области:- Все противоэпидемические вопросы находятся под постоянным контролем акима области. Руководителям районов поручено усилить профилактические меры. При этом приоритет - безопасность медицинских работников. На данный момент все медицинские учреждения Приаралья обеспечены лекарственными препаратами. Из средств местного бюджета в необходимом объёме закуплены защитные костюмы, маски, респираторы, перчатки и дезинфицирующие средства.В целом, в Приаралье из стран с категорией риска «1а» прибыли 4 человека. Все они помещены в карантин. Коронавируса у них не обнаружено. Ещё 9 человек сейчас находятся под домашним наблюдением. Авторы: Райхан Тажибаева, Канат Енсебаев, Айтмухамбет Байдулдаев",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/935020",
        "date": "2020-03-24, 10:15:52",
        "title": "Бразилия закрыла сухопутную границу с Уругваем из-за коронавируса",
        "text": "Оказавшихся в Бишкеке казахстанок с больными детьми доставят в Атырау 24 марта Правительство Бразилии приняло решение о закрытии сухопутной гр...",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/935017",
        "date": "2020-03-24, 10:11:53",
        "title": "О состоянии инфицированных COVID-19 в Алматы рассказали врачи",
        "text": "В мегаполисе число заражённых коронавирусом достигло уже 25 человек. Последние пациенты контактировали с заболевшими и были на карантине в стационаре. Начато их лечение, состояние удовлетворительное, отмечают специалисты. Сейчас в городской инфекционной больнице находятся 22 человека, в детской больнице - 2 ребёнка и мама с диагнозом COVID-19. Тлеухан Абилдаев, руководитель управления общественного здоровья города Алматы:- У двоих состояние средней тяжести, у остальных заболевших удовлетворительно. На 23 марта 2020 года в провизорных госпиталях на карантине находятся 660 граждан, на карантинных объектах находятся 778 человек, на домашнем карантине 1472 человека. У всех находящихся на карантине температура в пределах нормы, катаральных явлений нет, состояние удовлетворительное.",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/935013",
        "date": "2020-03-24, 10:00:25",
        "title": "Число заболевших коронавирусом в Пакистане достигло почти 800",
        "text": "Нарушителей карантина в Греции штрафуют на пять тысяч евро Число заболевших новым коронавирусом в Пакистане составило 799 человек, сообщает РИА...",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/935012",
        "date": "2020-03-24, 09:59:25",
        "title": "Приговоренный к 23 годам тюрьмы Вайнштейн заразился коронавирусом",
        "text": "Напомним, что ранее суд приговорил Харви Вайнштейна, который был известной фигурой в мире кино, к 23 годам тюремного заключения за совершения сексуальных преступлений.",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/935008",
        "date": "2020-03-24, 09:53:26",
        "title": "Қазақстанда коронавирус жұқтырғандар саны артты",
        "text": "Қазақстанда коронавирус жұқтырғандар саны 61 адамға жетті, ең көп науқас Нұр-Сұлтан қаласында тіркеліп отыр, одан кейін Алматы тұр",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/935007",
        "date": "2020-03-24, 09:51:26",
        "title": "Еще один случай заражения коронавирусом выявили в Алматы",
        "text": ", передает zakon. kz. Зарегистрирован еще 1 случай заражения коронавирусной инфекцией в г. Алматы. На сегодняшний день в стране подтверждено 61 случай регистрации коронавируса, из них Нур-Султан \u2013 31 случай, Алматы \u2013 26 случаев, Караганда - 2 случая, Алматинская область - 1 случай, Актюбинская область - 1 случай, - говорится в сообщении Минздрава...",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/935006",
        "date": "2020-03-24, 09:51:26",
        "title": "Алматыда тағы бір адамнан коронавирус табылды",
        "text": "Қазақстан денсаулық сақтау министрлігі 23 наурыз түс кезінде Алматыда тағы бір адамнан коронавирус анықталғанын хабарлады. Науқас туралы әзірге дерек жоқ. Қазір Қазақстанда барлығы 61 адам Covid-19 дертіне шалдықты. Нұр-Сұлтанда - 31 адам, Алматы қаласында - 26 адам, Қарағанды қаласында - екі адам, Алматы облысында - бір адам, Ақтөбе облысында бір адам емделіп жатыр. Коронавирус бойынша Қазақстандағы және әлемдегі жағдай жайлы мына сілтемеден оқи аласыз.",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/935005",
        "date": "2020-03-24, 09:50:27",
        "title": "Алматыда коронавирус жұқтырған тағы бір адам анықталды",
        "text": "АЛМАТЫ. ҚазАқпарат - Алматыда тағы 1 адамнан коронавирус шықты, деп хабарлайды ҚазАқпарат Денсаулық сақтау министрлігіне сілтеме жасап.",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/935000",
        "date": "2020-03-24, 09:43:28",
        "title": "Ещё одного заражённого коронавирусом выявили в Алматы",
        "text": "Итого сейчас в Казахстане 61 человек, заражённый Covid-19.",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/935001",
        "date": "2020-03-24, 09:42:28",
        "title": "26-й случай заражения коронавирусом выявили в Алматы",
        "text": "Об эпидемиологической ситуации по коронавирусуОб эпидемиологической ситуации по коронавирусуОб эпидемиологической ситуации по коронавирусуОб эпидемиологической ситуации по коронавирусуОб эпидемиологической ситуации по коронавирусу",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934998",
        "date": "2020-03-24, 09:35:29",
        "title": "Карта распространения коронавируса: число заболевших COVID-19 превысило 336 тысяч",
        "text": "НУР-СУЛТАН. КАЗИНФОРМ - Число случаев инфицирования COVID-19 в мире по состоянию на утро 23 марта превысило 336 тыс., из них более 200 тыс. \u2014 активные, передает корреспондент МИА «Казинформ».",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/935004",
        "date": "2020-03-24, 09:34:27",
        "title": "Еще 1 случай заражения COVID-19 в Алматы",
        "text": "Зарегистрирован еще 1 случай заражения коронавирусной инфекцией в городе Алматы. На сегодняшний день в стране подтверждено 61 случай регистрации коронавируса, из них в городе Нур-Султан \u2013 31 случай, город Алматы \u2013 26 случаев, город Караганда - 2 случая, Алматинская область - 1 случай, Актюбинская область - 1 случай.",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934996",
        "date": "2020-03-24, 09:33:29",
        "title": "Қытайда коронавирус жұқтырғандардың 90 процентке жуығы сауығып шықты",
        "text": "Бүгінде елдің мемлекеттік денсаулық сақтау комитеті індеттің беті қайта бастағанын ресми түрде хабарлады",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934986",
        "date": "2020-03-24, 09:12:32",
        "title": "Ударим частушками по коронавирусу ВИДЕО",
        "text": "...",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934968",
        "date": "2020-03-24, 08:37:04",
        "title": "На слухи о заражении коронавирусом сотен рабочих ответили власти Актобе",
        "text": "Глава упрздрава Актюбинской области прокомментировал слухи о том, что зараженный COVID-19 заразил около сотни рабочих в Хромтау, передает NUR.KZ.",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934965",
        "date": "2020-03-24, 08:30:05",
        "title": "Число случаев заражения коронавирусом в Британии достигло 5683",
        "text": "Военнослужащие перечислили однодневную зарплату на борьбу с коронавирусом Количество случаев заражения коронавирусом в Великобритании за сутки...",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934961",
        "date": "2020-03-24, 08:25:06",
        "title": "Алматыда коронавирус табылған екі адам ауруды Қазақстанда жұқтырған",
        "text": "Қазіргі уақытта Алматыда коронавирус жұқтырған 25 адам ауруханада жатыр, олардың екеуінің жағдайы орташа, қалғандарының денсаулығы бірқалыпты",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934960",
        "date": "2020-03-24, 08:17:06",
        "title": "Узбекистан закрыл контрольно-пропускные пункты на границе с Казахстаном",
        "text": "Власти закрыли границу из-за пандемии коронавируса. Гражданам запрещается выходить на улицу без медицинской маски.",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934959",
        "date": "2020-03-24, 08:14:06",
        "title": "В ВОЗ рассказали, когда появится вакцина от коронавируса",
        "text": "Разработка и испытание вакцины в общей сложности займет не менее года, передает ИА «NewTimes.kz» со ссылкой на Telegram-канал КККБТУ Казахстана....",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934957",
        "date": "2020-03-24, 08:09:04",
        "title": "Закроют ли на карантин Актобе из-за коронавируса",
        "text": "Глава упрздрава Актюбинской области ответил на волнующий многих жителей области вопрос о том, закроют ли регион на карантин из-за COVID-19 \u2013 здесь зарегистрирован первый случай заболевания, пишет NUR.KZ.",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934953",
        "date": "2020-03-24, 08:00:05",
        "title": "Военнослужащие перечислили однодневную зарплату на борьбу с коронавирусом",
        "text": "Во Франции от коронавируса умер первый врач Военнослужащие Министерства обороны РК перечислили свой однодневный заработок в созданный Фонд помо...",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934952",
        "date": "2020-03-24, 07:56:06",
        "title": "Дәрігерлер Алматыда коронавирус жұқтырған науқастардың жағдайы туралы айтты",
        "text": "аАЛМАТЫ. ҚазАқпарат -Алматыда коронавирус жұқтырған 2 науқас пен 1 баланың денсаулығы орта ауырлық жағдайында. Бұл туралы Алматыда қалалық қоғамдық денсаулық сақтау басқармасының басшысы Тілеухан Әбілдаев айтты, деп хабарлайды ҚазАқпарат тілшісі.",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934950",
        "date": "2020-03-24, 07:55:06",
        "title": "Ақтөбеде коронавирус жұқтырған әйелмен байланыста болған 68 адам карантинге жабылды",
        "text": "Кеше Ақтөбе облысында коронавирус жұқтырудың алғашқы оқиғасы тіркелгені хабарланды, әйел Мәскеуден ұшып келген",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934949",
        "date": "2020-03-24, 07:54:06",
        "title": "Пласидо Доминго заразился коронавирусом",
        "text": "Оперный певец Пласидо Доминго заразился коронавирусом. Доминго призвал всех быть предельно осторожными с связи со сложившейся ситуации, отнестись к кронавирусу серьезно.",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934948",
        "date": "2020-03-24, 07:51:07",
        "title": "Коронавирус в Казахстане: Двое заболевших пациента заразились в РК",
        "text": "О состоянии здоровья зараженных коронавирусом в Алматы, рассказал руководитель Управления здравоохранения мегаполиса Тлеухан Абильдаев. Оказалось,то двое заболевших заразились в Казахстане, передает zakon...",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934947",
        "date": "2020-03-24, 07:50:07",
        "title": "Казахстанский караоке-клуб запустил провокационную акцию на тему коронавируса: Мы ради вас вышли на работу, вы ради нас приходите поужинать",
        "text": "Мнения разделились. Один из казахстанских караоке-клубов запустил провокационную СММ-акцию в Instagram, сообщает медиа-портал Caravan.kz. С фотографии...",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934945",
        "date": "2020-03-24, 07:49:07",
        "title": "Состояние двоих заражённых коронавирусом в Алматы средней степени тяжести",
        "text": "Всего в Алматы по данным на утро 23 марта 25 человек заражены коронавирусом.",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934946",
        "date": "2020-03-24, 07:49:07",
        "title": "О двух новых заболевших коронавирусом в Алматы рассказали медики",
        "text": "АЛМАТЫ. КАЗИНФОМ \u2013 В Алматы рассказали о состоянии заболевших коронавирусом, передает корреспондент МИА «Казинформ».",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934942",
        "date": "2020-03-24, 07:42:08",
        "title": "Ақтөбедегі коронавиус жұқтырған адам Ресейден келген",
        "text": "АҚТӨБЕ. ҚазАқпарат \u2013 Ақтөбеде коронавирус жұқтырған адам Мәскеуден ұшып келген. Қазір бір рейспен келген 57 адам да оқшауланды, деп хабарлайды ҚазАқпарат тілшісі.",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934943",
        "date": "2020-03-24, 07:41:08",
        "title": "Подробности о двух зараженных коронавирусом в Алматы рассказали в управздраве",
        "text": "согласно последним данным, в Республике Казахстан зафиксировали 60 случаев заражения коронавирусом. Аким Нур-Султана обратился к гражданам, сообщив им об ужесточении мер.",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934939",
        "date": "2020-03-24, 07:36:09",
        "title": "Полиция раздала маски и перчатки малообеспеченным семьям",
        "text": "В связи со сложившейся ситуацией с коронавирусом в стране полицейские совместно с волонтёрами провели благотворительную акцию по раздаче защитных средств. Об этом сообщила пресс-служба департамента полиции Мангистауской области....",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934938",
        "date": "2020-03-24, 07:35:09",
        "title": "Денсаулық басқармасы Ақтөбеде коронавирус табылған науқас туралы айтты",
        "text": "23 наурызда Ақтөбе облыстық денсаулық сақтау басқармасы бір күн бұрын коронавирус анықталған әйелдің жағдайы туралы айтты. Ол қазір Ақтөбедегі провизорлық ауруханада жатыр. Науқастың жағдайы тұрақты деді Ақтөбе облыстық денсаулық сақтау басқармасы басшысы Әсет Қалиев. Оның айтуынша, науқас 22 наурызда Мәскеуден ұшып келген. Келген соң бірден дәрігерлер бақылауына алынған. Онымен бірге бортта болған 57 адам ауруханада карантинде жатыр. Олардан коронавирус анықталмаған. Жолаушылардың барлығы - Қазақстан азаматы. Науқас Ақтөбе қаласында тұрады. Қазір Қазақстанда барлығы 60 адам Covid-19 дертіне шалдықты. Нұр-Сұлтанда - 31 адам, Алматы қаласында - 25 адам, Қарағанды қаласында - екі адам, Алматы облысында - бір адам, Ақтөбе облысында - бір адам коронавирус жұқтырды. Қарай отырыңыз: Қазақстандағы коронавирус динамикасы Қазақстанда коронавирусқа байланысты 15 сәуірге дейін төтенше жағдай. 19 наурыздан бастап Алматы мен Нұр-Сұлтан қалалары карантинге көшті. Сауда және ойын-сауық орталықтары, тамақтан басқа зат сататын дүкендер мен сауда орындарының жұмысы тоқтатылды. Карантин режимі кезінде қоғамдық тамақтандыру орындары мен мейрамханалар тұтынушыға ас-суды үйіне жеткізіп береді. 22 наурыздан бастап Алматы мен Нұр-Сұлтан қаласына темір жол және ішкі рейстер тоқтады. 23 наурыздағы дерекке сай, әлемде коронавирус жұқтырғандар саны - 330 мыңнан, қаза тапқандар 14 мыңнан асып кетті. 98 мыңдай адам дерттен айықты. Дүниежүзілік денсаулық сақтау ұйымы Covid-19 коронавирусын пандемия деп жариялаған. Коронавирус бойынша Қазақстандағы және әлемдегі жағдай жайлы мына сілтемеден оқи аласыз.",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934937",
        "date": "2020-03-24, 07:34:10",
        "title": "Казахстанский караоке клуб запустил провокационную акцию на тему коронавируса: мы ради вас вышли на работу, вы ради нас приходите поужинать",
        "text": "Мнения разделились. Один из казахстанских караоке клубов запустил провокационную СММ-акцию в Instagram, сообщает медиа-портал Caravan.kz. С...",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934936",
        "date": "2020-03-24, 07:34:10",
        "title": "Полиция раздала маски и перчатки малообеспеченным семьям",
        "text": "В связи со сложившейся ситуацией с коронавирусом в стране полицейские совместно с волонтёрами провели благотворительную акцию по раздаче защитных средств. Об этом сообщила пресс-служба департамента полиции Мангистауской области....",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934933",
        "date": "2020-03-24, 07:28:11",
        "title": "Во Франции от коронавируса умер первый врач",
        "text": "Швейные цеха театров шьют маски для многодетных семей в СКО Первый врач, который боролся с коронавирусной инфекцией COVID-19, скончался во Фр...",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934932",
        "date": "2020-03-24, 07:21:11",
        "title": "Цены на нефть с начала года снизились на 60 процентов",
        "text": "НУР-СУЛТАН. КАЗИНФОРМ - Цены на нефть сегодня упали, поскольку правительства усилили меры по ограничению доступа, чтобы обуздать распространение глобальной вспышки коронавируса, передает МИА «Казинформ» со ссылкой на на REUTERS.",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934931",
        "date": "2020-03-24, 07:21:11",
        "title": "Что известно о состоянии зараженной коронавирусом в Актюбинской области",
        "text": "О состоянии зараженного коронавирусом в Актюбинской области рассказали в Управлении здравоохранения региона, передает zakon. kz. Пациентка прибыла вчера, 22 марта утренним рейсом из-за рубежа...",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934929",
        "date": "2020-03-24, 07:14:12",
        "title": "Ақтөбеде коронавирус табылған адаммен байланыста болғандардың барлығы оқшауландырылды",
        "text": "НҰР-СҰЛТАН. ҚазАқпарат -Ақтөбеде коронавирус табылған адаммен қарым-қатынаста болғандардың барлығы оқшауландырылды. Бұл туралы Ақтөбе облыстық денсаулық сақтау басқармасының басшысы Әсет Қалиев айтты, деп хабарлайды ҚазАқпарат тілшісі.",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934924",
        "date": "2020-03-24, 07:13:13",
        "title": "Заражённая коронавирусом в Актюбинской области прибыла из-за границы",
        "text": "Инфицированную Covid-19 в Актюбинской области выявили 22 марта. Всего в Казахстане 60 человек заражены коронавирусом.",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934922",
        "date": "2020-03-24, 07:13:13",
        "title": "Нұр-Сұлтан әуежайында ер адам қайтыс болды",
        "text": "Жолаушылардың айтуынша, ер адамда коронавирус белгілері болмаған. Оның мәйіті сот-медициналық сараптамаға жөнелтілді",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934927",
        "date": "2020-03-24, 07:13:12",
        "title": "Коронавирус в Актюбинской области: стали известны подробности о зараженном",
        "text": "Накануне диагноз коронавирусная инфекция COVID-19 впервые зарегистрировали в Актюбинской области Казахстана. Сегодня стали известны подробности об этом случае заражения, сообщает NUR.KZ.",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934915",
        "date": "2020-03-24, 06:40:54",
        "title": "Европе для победы над коронавирусом может потребоваться до двух лет",
        "text": "Странам Европы не следует рассчитывать на скорую победу над коронавирусом, для этого государствам может потребоваться до двух лет, сообщает zakon. kz со ссылкой на Lenta...",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934914",
        "date": "2020-03-24, 06:36:54",
        "title": "Количество зараженных коронавирусом по всему миру превысило 337 тыс. человек",
        "text": "Только за последние 24 часа число зараженных увеличилось на 31 тыс. человек. Отмечается, что больше всего новых инфицированных за последние сутки выявили в США - около 9 тыс. человек, следом идет Италия - свыше 5,5 тыс.",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934911",
        "date": "2020-03-24, 06:35:55",
        "title": "В Китае выздоровели 90 процентов больных коронавирусом",
        "text": "В Китае выздоровели почти 90 процентов больных коронавирусом. Сейчас в стране болеют 5 120 человек, передает Tengrinews.kz со ссылкой на РИА Новости....",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934908",
        "date": "2020-03-24, 06:30:56",
        "title": "Германия канцлері Ангела Меркель үйден жұмыс істей бастады",
        "text": "Германия канцлері Ангела Меркель жексенбі, 22 наурызда үйде қалып, карантин режиміне көшті. Германия үкіметінің ресми өкілі Штеффен Зайберттің сөзіне қарағанда екі күн бұрын Меркель барған дәрігерден коронавирус табылған. Ол кезде дәрігер Меркельге пневмомок инфекциясына қарсы екпе салған. Ангела Меркель бірнеше күн бойы коронавирус бойынша тестен өтпек. Ол қызметтік міндетін карантин жағдайында үйден атқара береді. Коронавирусқа байланысты соңғы ақпаратты білу үшін мына сілтемені басыңыз.",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934909",
        "date": "2020-03-24, 06:30:56",
        "title": "В Китае выздоровели почти 90% зараженных новым вирусом",
        "text": "Число больных коронавирусом в Китае с каждым днем снижается, сейчас в больницах остаются 5 120 человек, при этом почти 90% всех зараженных выздоровели, передает zakon. kz со ссылкой на РИА Новости...",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934910",
        "date": "2020-03-24, 06:30:55",
        "title": "В США за сутки выявлено более 9 тыс. новых заражений коронавирусом",
        "text": "По данным международной группы волонтеров Worldometer, в США за последние сутки коронавирус SARS-CoV-2 был выявлен более чем у 9 100 человек, сообщает zakon. kz со ссылкой на DW. К 23 марта вирус SARS-CoV-2 обнаружен у 33 546 жителей США...",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934906",
        "date": "2020-03-24, 06:20:56",
        "title": "Коронавирус Қазақстанда: оқиғалар хронологиясы. Оныншы күн",
        "text": "Informburo.kz оныншы күннің оқиғаларын рет-ретімен әңгімелейді.",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934905",
        "date": "2020-03-24, 06:18:57",
        "title": "Қазақстанда тағы бір адамнан коронавирус табылды - науқастардың саны 60 болды",
        "text": "Ең көп коронавирус жұқтырғандар саны Нұр-Сұлтан қаласында тіркеліп отыр - 31 адам, одан кейін Алматы тұр",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934904",
        "date": "2020-03-24, 06:14:57",
        "title": "МОК: Рассматривается перенос даты Олимпиады 2020",
        "text": "Международный олимпийский комитет провёл экстренное заседание исполкома в связи с пандемией коронавируса.",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934902",
        "date": "2020-03-24, 06:10:57",
        "title": "Нигматулин: YDD Corporation выделил 100 миллионов тенге на борьбу с коронавирусом",
        "text": "YDD Corporation выделил 100 миллионов тенге на борьбу с коронавирусом, сообщает zakon. kz. Карагандинский ферросплавный завод YDD Corporation выделил 100 миллионов тенге в Карагандинский областной фонд, созданный для поддержки действий государства в условиях чрезвычайного положения...",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934901",
        "date": "2020-03-24, 06:07:58",
        "title": "Сирияда коронавирус жұқтырудың алғашқы оқиғасы тіркелді",
        "text": "ДАМАСК. ҚазАқпарат \u2013 Сирияда коронавирус жұқтырудың алғашқы оқиғасы тіркелді, деп хабарлайды ҚазАқпарат SANA агенттігіне сілтеме жасап.",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934899",
        "date": "2020-03-24, 06:03:58",
        "title": "Нам и коронавирус не нужен, сплошная зараза : реки Талгара превратились в большую помойку",
        "text": "Если бы существовала статуэтка-приз в виде мусорной горы с символичным titleм Самый грязный , уверена...",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934865",
        "date": "2020-03-24, 04:30:51",
        "title": "За сутки в мире выявили более 31 тыс. новых случаев заражения коронавирусом",
        "text": "Согласно данным сайта worldometers. info, число заболевших новым коронавирусом COVID-19 на этот момент достигло в мире 336 075 человек. С начала пандемии скончалось 14 613человек, сообщает zakon...",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934856",
        "date": "2020-03-24, 03:59:54",
        "title": "Қазақстанда коронавирусқа шалдыққандар саны 60 адамға жетті",
        "text": "АЛМАТЫ. ҚазАқпарат - Қазақстанда тағы бір адам коронавирус инфекциясын жұқтырдлы, деп хабарлайды ҚазАқпарат.",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934847",
        "date": "2020-03-24, 02:22:35",
        "title": "Түркістан облысында «Сақшы» жобасы басталды",
        "text": "ТҮРКІСТАН. ҚазАқпарат - COVID-19 коронавирус инфекциясының облыста таралмауының алдын-алу мақсатында Түркістан облысында түрлі деңгейдегі шаралар атқарылуда. Осы орайда, әлеуметтік, кәсіпкерлік нысандар мен адам көп жиналатын қоғамдық орындардың жұмыс режимі өзгеріп, шектеу қойылды, деп хабарлайды ҚазАқпарат.",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934846",
        "date": "2020-03-24, 02:16:35",
        "title": "Коронавирус: Япония рассматривает варианты переноса Олимпиады-2020",
        "text": "Организационный комитет Олимпиады-2020 в Токио начал рассматривать альтернативы проведению Игр этим летом, несмотря на заверения правительства Японии в том, что перенос соревнований не обсуждается",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934845",
        "date": "2020-03-24, 01:59:48",
        "title": "Covid-19. Әлем елдері бір-біріне қол ұшын созып жатыр",
        "text": "Жер жаһан Covid-19 коронавирусына қарсы күресіп жатыр. Жан алысып, жан беріскен «шайқас» көп елге ауыр зардап тигізіп, коронавирус дүниежүзіне экономикалық соққы да жасады. Алыс-берісі, барыс-келісі тоқтаған халық үйде қамалып отыр. Үміт те бар. Вирус ошағы болған Қытай тұрғындары көшеге қайта шыға бастады.",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934843",
        "date": "2020-03-24, 01:07:48",
        "title": "Как долго коронавирус остается на разных typeах поверхностей?",
        "text": "По всему миру сейчас можно наблюдать одинаковую картину: люди пытаются открыть двери локтями, пассажиры в общественном транспорте стараются не касаться поручней, а офисные работники каждое утро усердно протирают свои столы.",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934840",
        "date": "2020-03-24, 00:29:20",
        "title": "Жители столицы поют гимн с балконов на домашнем карантине",
        "text": "НУР-СУЛТАН. КАЗИНФОРМ - В Казахстане переняли «итальянский способ» поднятия духа в самоизоляции из-за пандемии коронавируса COVID-19. Музыкальный флешмоб в одном из столичных жилых комплексов попал на видео, передает МИА «Казинформ».",
        "type": "Новость"
    },
    {
        "URL": "http://forum.vsalde.ru/index.php?showtopic=434705&view=findpost&p=2669962",
        "date": "2020-03-23, 22:32:07",
        "title": "Re: Последние новости и их обсуждение",
        "text": "Наш журналист в Италии. Ведет каждодневные отчеты. Вот сегодняшний:\r\n \r\n Шел 13-й день итальянского карантина\u2026 За сутки выявлено 5.560 зараженных (с начала эпидемии \u2013 59.138). Вчера суточный прирост был выше - 6.557. Скончалось за сутки 651 (с начала эпидемии \u2013 5.476). Для сравнения: вчера умерло 793 человека.\r\n \r\n Особое внимание, как и раньше, приковано к Ломбардии. Это, между прочим, самый густонаселенный и промышленно развитый регион Италии, там проживает каждый шестой итальянец. В Ломбардии за сутки зарегистрирован 1.691 новый случай, и это вдвое меньше, чем вчера (3.251). Скончалось 361 (вчера 546). Переломилась ли ситуация, пока делать вывод рано. Как некую надежду на скорый выход из кризиса дает следующая цифра. Если в начале карантина 60% тестов на коронавирус в Ломбардии стабильно давали положительный результат, сейчас эта цифра снизилась до 33%. При этом критерии выбора тестируемых не изменились.\r\n \r\n Профессор университета Падуи, бывший президент Европейского общества вирусологов Джорджио Пало полагает, что с самого начала эпидемии в этом регионе был допущен ряд непростительных ошибок. Основная: недопустимо высоким был процент госпитализации. В Ломбардии на первом этапе госпитализировали 66% пациентов с выявленным коронавирусом, хотя большинство из них не нуждалось в госпитализации (в соседнем Венето, для сравнения, госпитализировали каждого четвертого). Таким образом были созданы условия для внутрибольничного распространения вируса, который на каком-то этапе даже стал основным путем заражения. Слишком много пациентов, особенно пожилых, заразились коронавирусом уже в больницах, где они находились по совершенно другим причинам. Вирус оказался более коварным, чем о нем думали, и соблюдающий обычные нормы безопасности персонал стал невольным переносчиком инфекции. Это была фатальная ошибка. Жертвами стали не только пациенты, но и медики: цифры заразившихся и даже умерших врачей и медсестер в Ломбардии это подтверждают. Кстати, первые десятки заразившихся от «пациента №1» в больнице Лоди \u2013 это было как раз внутрибольничное заражение.\r\n \r\n В интервью La Stampa мэр Бергамо Джорджио Гори рассказал о драматической ситуации в провинции, наиболее пострадавшей от коронавируса. «Мы находимся в разгаре войны. Больно смотреть, как на наших глазах уничтожается целое поколение. И мы даже не имеем возможности достойно проводить их в последний путь». Мэр поприветствовал 600 волонтеров со всей страны, которые приехали в Бергамо, чтобы помочь городу пережить эту ужасную трагедию, и рассказал о многих инициативах местных добровольцев. Среди акций, которые его особенно тронули, инициатива работников муниципальных библиотек. Библиотеки закрыты, но их сотрудники из своих домов целыми днями читают вслух детские книги и выкладывают эти записи в интернете.\r\n \r\n Тем временем мэр ломбардийского города Кремона Джанлука Галимберти объявил, что у него положительный анализ на коронавирус. В своем фейсбуке он рассказал о своих симптомах (жар, кашель, озноб) и сообщил, что изолируется дома, отделив от себя семью. Он призвал жителей Кремоны соблюдать строжайший карантин. Всего в провинции Кремона заразились 2.895 человек.\r\n \r\n Правительство еще более ужесточило режим карантина. С завтрашнего дня должны закрыться все промышленные предприятия, кроме имеющих стратегическое значение. Думаете, стратегические \u2013 это ВПК? Разумеется, нет. Это производство продуктов питания, товаров медицинского назначения, товаров, обеспечивающих работу общественного транспорта и связи. «Да, мы останавливаем экономический мотор страны, - сказал в обращении к нации премьер Конте, - Мы понимаем, на какую жертву мы идем, но эта жертва не идет ни в какое сравнение с тем, на какие жертвы идут наши врачи в больницах. Вот кто настоящие герои».\r\n \r\n И только что вышло совместное распоряжение министров внутренних дел и здравоохранения Италии, запрещающее любое перемещение физических лиц в любом транспорте \u2013 как личном, так и общественном, - вне территории муниципалитета, в котором эти физические лица проживают.\r\n \r\n Продолжает приходить помощь из-за границы. 1,5 миллиона медицинских масок прислал Египет, 40 тысяч \u2013 Индия, очередные 2 миллиона пришло из Евросоюза, 2,5 миллиона из Бразилии, днем пришло 2,5 миллиона из Китая и ночью придет еще миллион. Ждут военные самолеты с помощью из России. Пока неизвестно, что они привезут, но судя по российским СМИ, активно освещающим эту акцию, там будет сто военных специалистов по дезинфекции и поливальные машины, заполненные дезинфицирующим раствором для дезинфекции транспорта и для распыления на улицах. Итальянцы, правда, не планируют обрабатывать асфальт, но, возможно, российские военные специалисты сумеют их убедить. Готовятся к вылету с аэродрома Чкаловский и восемь медицинских бригад, включающих врачей и медсестер, и вот это уже хорошо.\r\n \r\n Попала в печать некрасивая история, случившаяся в Чехии. Там на складе в Лосовице на днях была конфискована идущая в Италию транзитом из Китая партия из 680 тысяч медицинских масок и 28 тысяч респираторов. Это была гуманитарная помощь Китайского Красного Креста. И хотя на каждой коробке было изображение китайского и итальянского флагов, а все документы были оформлены в полном соответствии с международными нормами, чешская таможня конфисковала всю партию. В течение трех дней чешские власти отвечали на запросы китайцев и итальянцев одноtypeно: «Эти товары похищены у чешских компаний недобросовестными людьми, которые хотели продавать их по более высокой цене на международном рынке, по факту чего возбуждено уголовное дело». И только сегодня после многократных протестов итальянского посольства в Праге министр иностранных дел Чехии Томаш Петржичек связался с главой итальянского МИДа Луиджи Ди Майо, признал ошибку и пообещал в качестве компенсации предоставить Италии 110 тысяч медицинских масок. Те, что прислал Китай, видите ли, уже распределены по чешским учреждениям здравоохранения. Прямо по Корнею Чуковскому: «Ах, те, что ты выслал на прошлой неделе, мы давно уже съели»",
        "type": "Комментарий"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934821",
        "date": "2020-03-23, 22:15:19",
        "title": "Защитит ли от коронавируса прививка от гриппа, объяснили специалисты из ВОЗ",
        "text": "В ВОЗ пояснили, способна ли вакцина от гриппа защитить от коронавируса SARS-CoV-2. Ранее информация об этом появлялась в разных СМИ.",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934820",
        "date": "2020-03-23, 22:12:19",
        "title": "Контактировавших с больным коронавирусом жамбылцев проверили на заражение",
        "text": "Анализы десяти жителей Жамбылской области, которые контактировали с больным коронавирусом, показали отрицательный результат, передает zakon. kz. По информации пресс-службы акимата региона, все контактировавшие ранее с больным коронавирусом жителем Алматинской области 10 жителей Жамбылской области выявлены и помещены в карантин...",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934819",
        "date": "2020-03-23, 22:07:20",
        "title": "Ангела Меркельге екпе жасаған дәрігер коронавирус жұқтырған: Канцлер карантинде жатыр",
        "text": "БРЮССЕЛЬ. ҚазАқпарат \u2013 Германия канцлері Ангела Меркель COVID-19 вирусын жұқтырған дәрігермен қарым-қатынас жасаған соң карантинге жатты. Бұл туралы канцлердің ресми өкілі Штеффен Зайберт мәлімдеді, деп хабарлайды ҚазАқпарат тілшісі.",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934817",
        "date": "2020-03-23, 21:56:48",
        "title": "Ангела Меркель ушла на карантин после контакта с инфицированным COVID-19",
        "text": "БРЮССЕЛЬ. КАЗИНФОРМ - Канцлер Германии Ангела Меркель отправилась на карантин после контакта с врачом, инфицированным коронавирусом COVID-19. Об этом в воскресенье сообщил официальный представитель канцлера Штеффен Зайберт, передает собственный корреспондент МИА «Казинформ».",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934814",
        "date": "2020-03-23, 21:51:49",
        "title": "Скандальный боксер заявил о бездомном будущем из-за коронавируса",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934812",
        "date": "2020-03-23, 21:33:50",
        "title": "Тренер европейского клуба футболиста сборной Казахстана рассказал об особенностях тренировок во время коронавируса",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934804",
        "date": "2020-03-23, 21:14:52",
        "title": "Двадцать пятый случай коронавируса выявили в Алматы: в Казахстане 60 заболевших",
        "text": "АЛМАТЫ. КАЗИНФОРМ - На 23.50 22 марта 2020 года в Казахстане зарегистрирован еще один случай заражения коронавирусной инфекцией в городе Алматы, передает МИА «Казинформ» со ссылкой на Telegram-канал Комитета контроля качества и безопасности товаров и услуг МЗ РК.",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934802",
        "date": "2020-03-23, 21:11:52",
        "title": "Алматыда бір күнде үшінші адам Covid-19 дертіне шалдықты",
        "text": "Алматы қаласында тағы бір адамнан коронавирус табылды. Бұл туралы 22 наурыз 23.50-де Денсаулық сақтау министрлігі хабарлады. Сонымен, 22 наурызда Қазақстанда алты адам дертке шалдыққаны белгілі болды. Алматыда үш адам, Нұр-Сұлтанда екі адам, Ақтөбе облысында бір адам жұқтырған. Қазір Қазақстанда барлығы 60 адам Covid-19 дертіне шалдықты. Нұр-Сұлтанда - 31 адам, Алматы қаласында - 25 адам, Қарағанды қаласында - екі адам, Алматы облысында - бір адам, Ақтөбе облысында - бір адам коронавирус жұқтырды. Қарай отырыңыз: Қазақстандағы коронавирус динамикасы Қазақстанда коронавирусқа байланысты 15 сәуірге дейін төтенше жағдай. 19 наурыздан бастап Алматы мен Нұр-Сұлтан қалалары карантинге көшті. Сауда және ойын-сауық орталықтары, тамақтан басқа зат сататын дүкендер мен сауда орындарының жұмысы тоқтатылды. Карантин режимі кезінде қоғамдық тамақтандыру орындары мен мейрамханалар тұтынушыға ас-суды үйіне жеткізіп береді. 22 наурыздан бастап Алматы мен Нұр-Сұлтан қаласына темір жол және ішкі рейстер тоқтады. 22 наурыздағы дерекке сай, әлемде коронавирус жұқтырғандар саны 300 мыңнан, қаза тапқандар 13 мыңнан асып кетті. 93 мыңдай адам дерттен айықты. Дүниежүзілік денсаулық сақтау ұйымы Covid-19 коронавирусын пандемия деп жариялаған. Коронавирус бойынша Қазақстандағы және әлемдегі жағдай жайлы мына сілтемеден оқи аласыз.",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934798",
        "date": "2020-03-23, 21:06:53",
        "title": "В Казахстане число зараженных коронавирусом выросло до 60",
        "text": "Читать дальше",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934794",
        "date": "2020-03-23, 20:57:25",
        "title": "Определен самый безопасный во время пандемии коронавируса транспорт",
        "text": "Определен самый безопасный во время пандемии коронавируса транспорт. Об этом «Звезде» рассказал иммунолог-инфекцонист, директор Научно-исследовательского центра по профилактике и лечению вирусных инфекций Георгий Викулов....",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934795",
        "date": "2020-03-23, 20:57:24",
        "title": "Қазақстанда коронавирус жұқтырғандар саны 60 болды",
        "text": "АЛМАТЫ. ҚазАқпарат - Қазақстанда тағы бір адам коронавирус инфекциясын жұқтырдлы, деп хабарлайды ҚазАқпарат.",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934793",
        "date": "2020-03-23, 20:54:25",
        "title": "Число заражённых коронавирусом в Казахстане достигло 60",
        "text": "Новый случай выявлен в Алматы.",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934792",
        "date": "2020-03-23, 20:52:25",
        "title": "В Кызылординской области задержали авторов фейков",
        "text": "Трех распространителей фейков в Кызылординской области привлекли к уголовной ответственности, передает zakon. kz. Согласно данным polisia. kz, они распространили через мессенджер сообщение, что в области имеются заболевшие коронавирусом...",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934790",
        "date": "2020-03-23, 20:43:26",
        "title": "У Пласидо Доминго диагностировали коронавирус",
        "text": "МАДРИД. КАЗИНФОРМ - Легендарный испанский оперный певец Пласидо Доминго заразился коронавирусной инфекцией COVID-19. Об этом 79-летний тенор сообщил в своем Facebook, передает МИА «Казинформ»",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934789",
        "date": "2020-03-23, 20:42:26",
        "title": "Как влияет коронавирус на курильщиков, рассказали в Минздраве России",
        "text": "Минздрав России заявил, что курильщики тяжелее переносят коронавирус, сообщает zakon. kz со ссылкой на РИА Новости . Курение является дополнительным фактором риска с точки зрения тяжести течения коронавирусной инфекции у пациента, - утверждает замминистр здравоохранения России Олег Салагай...",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934788",
        "date": "2020-03-23, 20:32:26",
        "title": "Обнародована динамика роста числа зараженных коронавирусом в России",
        "text": "RT опубликовал динамику роста эпидемии коронавируса в России, передает zakon. kz. Первый зараженный в РФ был обнаружен 5 марта. На данный момент в России зарегистрировано 367 зараженных коронавирусом...",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934787",
        "date": "2020-03-23, 20:28:26",
        "title": "ООН и ВОЗ хотят выделить Украине $58 миллионов на борьбу с COVID-19",
        "text": "Nissan временно уволил три тысячи рабочих на заводе в Испании Международные организации разрабатывают два плана помощи для Украины для борьбы с коронавирусом COVID-19, планируется выде...",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934786",
        "date": "2020-03-23, 20:24:27",
        "title": "Карта опасных из-за коронавируса зон в Казахстане появилась на eGov",
        "text": "На карте отмечены места, где находятся контактные и инфицированные.",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934780",
        "date": "2020-03-23, 20:11:42",
        "title": "Коронавирус в Казахстане: хронология событий. День десятый",
        "text": "Коротко рассказываем, что произошло в Казахстане на десятый день выявления коронавируса.",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934779",
        "date": "2020-03-23, 20:11:42",
        "title": "Оперный певец Пласидо Доминго заразился коронавирусом",
        "text": "Испанский оперный певец Пласидо Доминго сообщил о заражении коронавирусом, передает zakon. kz. Моя моральная обязанность сообщить, что у меня положительный тест на COVID19\u2026 Я и моя семья будем оставаться изолированными друг от друга столько, сколько необходимо с медицинской точки зрения, - написал певец в Facebook...",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934778",
        "date": "2020-03-23, 20:10:42",
        "title": "Коронавирус: 59 зараженных в Казахстане",
        "text": "Зарегистрирован еще 1 случай заражения коронавирусной инфекцией в городе Алматы. На сегодняшний день в стране подтверждено 59 случаев регистрации коронавируса, из них в городе Нур-Султан \u2013 31 случай, в Алмате \u2013 24 случая, в Караганде - 2 случая, в Алматинской области - 1 случай, в Актюбинской области - 1 случай.",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934771",
        "date": "2020-03-23, 19:51:44",
        "title": "Алматыда коронавирус жұқтырғандар саны 24-ке жетті",
        "text": "Алматыда тағы бір коронавирус инфекциясын жұқтыру жағдайы тіркелді, деп хабарлайды zakon. kz. 2020 жылы 22 наурызда сағат 21. 30-да Қазақстанда коронавирустық инфекцияның тағы бір жағдайы тіркелді...",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934769",
        "date": "2020-03-23, 19:42:44",
        "title": "Италияда бір тәулікте коронавирустан 800-ге тарта адам көз жұмды",
        "text": "РИМ. ҚазАқпарат \u2013 Италияда соңғы тәулікте коронавирус инфекциясынан көз жұмғандар саны күрт өсті, індет 793 адамның өмірін қиып кетті.",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934767",
        "date": "2020-03-23, 19:41:45",
        "title": "В Германии запретят людям собираться более чем по двое",
        "text": "Власти Германии ужесточили меры по противодействию распространению коронавируса, сообщает zakon. kz со ссылкой на ТАСС. Исключение сделают для семей и людей, живущих под одной крышей...",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934765",
        "date": "2020-03-23, 19:35:45",
        "title": "Военнослужащие перечислили однодневную зарплату на борьбу с коронавирусом",
        "text": "НУР-СУЛТАН. КАЗИНФОРМ - Военнослужащие Министерства обороны РК перечислили свой однодневный заработок в созданный Фонд помощи борьбы с коронавирусом. Об этом передает МИА «Казинформ» со ссылкой на пресс-службу Министерства обороны РК.",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934763",
        "date": "2020-03-23, 19:34:46",
        "title": "Қазақстанда коронавирус жұқтырғандардың саны 59-ға жетті",
        "text": "Алматыда бір адамнан коронавирус инфекциясы табылды, деп хабарлады денсаулық сақтау министрлігі. Бұл 22 наурызда анықталған бесінші науқас",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934762",
        "date": "2020-03-23, 19:28:46",
        "title": "Африка елдерінде коронавирус жұқтырғандар саны күрт артты",
        "text": "ПРЕТОРИЯ. ҚазАқпарат \u2013 Жексенбі күнгі мәліметтер бойынша, әлемде вирус жұқтырғандар саны 300 мыңнан асты. Олардың 13 мыңы мерт болды, 92 мың адам сауығып кетті.",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934759",
        "date": "2020-03-23, 19:22:46",
        "title": "Африке елдерінде коронавирус жұқтырғандар саны күрт артты",
        "text": "ПРЕТОРИЯ. ҚазАқпарат \u2013 Жексенбі күнгі мәліметтер бойынша, әлемде вирус жұқтырғандар саны 300 мыңнан асты. Олардың 13 мыңы мерт болды, 92 мың адам сауығып кетті.",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934750",
        "date": "2020-03-23, 19:12:48",
        "title": "В Узбекистане обнаружили 43 случай заражения коронавирусом",
        "text": "Количество подтвержденных случаев коронавируса в Узбекистане достигло 43, передает zakon. kz со ссылкой на Минздрав страны. Заболевание обнаружили у человека, прибывшего из Стамбула...",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934748",
        "date": "2020-03-23, 18:59:39",
        "title": "Патриарх Кирилл предположил, что коронавирус является божьей милостью",
        "text": "Священник поведал, как коронавирус повлиял на его службу. Патриарх Московский и всея Руси Кирилл утверждает...",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934747",
        "date": "2020-03-23, 18:57:39",
        "title": "В Казахстане число зараженных коронавирусом выросло до 59",
        "text": "Читать дальше",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934745",
        "date": "2020-03-23, 18:56:40",
        "title": "Нұр-Сұлтан қаласында карантин кезіндегі талаптар күшейтілді",
        "text": "НҰР-СҰЛТАН. ҚазАқпарат - Елорда әкімі Алтай Көлгінов коронавирус инфекциясының таралуына қарсы әрекет ету шараларын күшейту туралы айтты, деп хабарлайды елорда әкімдігінің баспасөз қызметі.",
        "type": "Новость"
    },
    {
        "URL": "http://kazakhstan.shafaqna.com/KZ/AL/934740",
        "date": "2020-03-23, 18:42:41",
        "title": "Алматының тағы бір тұрғынынан коронавирус табылды",
        "text": "АЛМАТЫ. ҚазАқпарат \u2013 Алматыда тағы да коонавирус жұқтыру жағдайы тіркелді, деп хабарлайды ҚазАқпарат ҚР ДСМ Тауарлар мен көрсетілетін қызметтердің сапасы мен қауіпсіздігін бақылау комитетінің Телеграм каналына сілтеме жасап.",
        "type": "Новость"
    }
]

        }
    },
    created(){
        this.loadAsync()
        setTimeout(this.appendTs, 1000);
    },
    methods:{
        loadAsync(){
            for (let k = this.currentx; k < 10+this.currentx;k++){
                    this.dd[k].date = (new Date()).toLocaleString()
                    this.dataS.push(this.dd[k])
            }
            this.currentx = 11;
        },
        appendTs(){
            this.dd[this.currentx].date = (new Date()).toLocaleString()
            this.dataS.unshift(this.dd[this.currentx]);
            this.currentx++;
            setTimeout(this.appendTs, 3600);
        }
    }
}
</script>
